<template>
	<div class='display-action'>
		<h2 class='display-header'>{{getText('RedirectHeader')}}</h2>
		<hr/>
		<div class='container'>
			<div class='row'>
				<div class='col-sm-12'>{{getText('RedirectLoadingMessage')}}</div>
			</div>
		</div>
	</div>
</template>


<script>

import { mapGetters } from "vuex";

// Language / Localization
import LanguageService from "@/common/language.service";

export default {
	name: "RedirectAction",
	components: {},
	beforeMount(){
		// On load, send user off to whichever link we have stored
		window.location.href = this.action().Redirect;
	},
	methods: {
		getText(key){
			return LanguageService.getText(key);
		},
		...mapGetters(["action"])
	}
}
</script>
